const styles = theme => ({
  accordionTitleHead: {
    padding: '4px 15px',
    borderBottom: '1px solid #EBEEF3',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      margin: '0 !important',
    },
    '& svg': {
      fontSize: '22px',
    },
    '& p': {
      fontSize: '14px',
      color: theme.palette.primary.adgmBlack,
      fontWeight: 600,
      marginLeft: '6px',
    },
    '& $mandatory': {
      color: theme.palette.primary.main,
    },
    '& img': {
      width: '24px',
      height: '24px',
    },
  },
  mandatory: {},
  accordionDetails: {
    padding: '0px 15px 4px 15px',
    borderBottom: '1px solid #EBEEF3',
    display: 'flex',
    flexDirection: 'column',
  },
  buttonContainer: {
    width: '100%',
    padding: '20px 0px 10px 0px',
  },
  button: {
    height: '36px',
    minWidth: '167px',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '10px',
    '& img': {
      marginRight: '4px',
      width: '12px',
    },
    '& p': {
      fontSize: '12px',
      fontWeight: 600,
    },
  },
  docsFlexContainer: {
    transition: 'all 1s',
    display: 'block',
    width: '100%',
    '& $fileFlex': {
      padding: '4px 0px',
      '& p': {
        fontSize: '12px',
      },
      '& img': {
        width: '20px',
        height: '20px',
      },
      '& button': {
        fontSize: '12px',
        fontWeight: 400,
        flexShrink: '0',
      },
    },
  },
  fileFlex: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '12px 0px',
    '& img': {
      marginRight: '12px',
    },
    '& button': {
      marginLeft: 'auto',
      textTransform: 'none',
      color: 'grey',
    },
  },

  '@media (max-width: 767px)': {
    accordionTitleHead: {
      minHeight: '48px !important',
      '& > div': {
        padding: '0',
      },
    },
  },
  '@media (min-width: 768px)': {
    buttonContainer: {
      padding: '20px 0px 10px 0px',
    },
    button: {
      height: '60px',
      minWidth: '228px',
      fontSize: '16px',
      borderRadius: '13.6111px',
      '& img': {
        marginRight: '8px',
        width: '17px',
      },
      '& p': {
        fontSize: '16px',
      },
    },
    accordionTitleHead: {
      padding: '4px 24px',
      '& p': {
        fontSize: '16px',
        marginLeft: '8px',
      },
      '& svg': {
        fontSize: '26px',
      },
      '& img': {
        width: '30px',
        height: '30px',
      },
    },
    accordionDetails: {
      padding: '0px 24px 8px 24px',
    },
    docsFlexContainer: {
      '& $fileFlex': {
        padding: '12px 0px',
        '& p': {
          fontSize: '14px',
        },
        '& img': {
          width: '32px',
          height: '32px',
        },
        '& button': {
          fontSize: '14px',
          fontWeight: 500,
        },
      },
    },
  },
});

export default styles;
